//import { StatusBar } from 'expo-status-bar';
import React from "react";
import { StyleSheet, Text, View } from 'react-native';
// redux
import { Provider } from 'react-redux'
import Store from './Store/store'
// Paper
import { Provider as PaperProvider } from 'react-native-paper'
// Navigation
//import Navigation from './Navigation/Navigation';
//import StackNavigator from './Navigation/Navigation';
import { NavigationContainer } from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';
//
//import Lancement from './Components/Lancement'
//import DeleteData from './Components/DeleteData'
//import CodeZRun from './Components/CodeZRun'
//import Profil from './Components/Profil'
//import ProfilEtCode from './Components/ProfilEtCode'
import ProfilEtProgrammes from './Components/ProfilEtProgrammes'
//import LoadProgramme from './Components/LoadProgramme'
//import Programme from './Components/Programme'
import ProgrammeGid from './Components/ProgrammeGid'
//import ListeSeances from './Components/ListeSeances'
//import MAJSeances from './Components/MAJSeances'
//import ListeSeancesMulti from './Components/ListeSeancesMulti'
//import MAJSeancesMulti from './Components/MAJSeancesMulti'

/*
<StackNavigator.Screen
  name="DeleteData"
  component={DeleteData}
  options={{ title: "DeleteData" }}
  />
*/
//ProfilEtCode
//Programme

//ProfilEtProgrammes
//ProgrammeGid

export default function App() {

  const StackNavigator = createStackNavigator();

  //const StoreInstance = Store();
  //StoreInstance.subscribe(() => localStorage.setItem('reduxState', JSON.stringify(StoreInstance.getState())));

  return (
    <Provider store={Store}>
      <PaperProvider>
        <NavigationContainer>
          <StackNavigator.Navigator initialRouteName="ProfilEtProgrammes">
            <StackNavigator.Screen
              name="ProfilEtProgrammes"
              component={ProfilEtProgrammes}
              options={{ title: "Mon Profil Z'Run" }}
              />
            <StackNavigator.Screen
              name="ProgrammeGid"
              component={ProgrammeGid}
              options={{ title: 'Mes Séances' }}
              />
          </StackNavigator.Navigator>
        </NavigationContainer>
      </PaperProvider>
    </Provider>
  )
}


  /*
  <StackNavigator.Screen
    name="Lancement"
    component={Lancement}
    options={{ title: 'Chargement...' }}
    />
  <StackNavigator.Screen
    name="CodeZRun"
    component={CodeZRun}
    options={{ title: "Mon Code Z'Run" }}
    />
  <StackNavigator.Screen
    name="Profil"
    component={Profil}
    options={{ title: "Mon Profil Z'Run" }}
    />
    <StackNavigator.Screen
      name="LoadProgramme"
      component={LoadProgramme}
      options={{ title: "Chargement du Programme" }}
      />
  */



const styles = StyleSheet.create({
  container: {
    marginTop: 30,
    flex: 1,
    backgroundColor: '#fff',
    alignItems: 'center',
    justifyContent: 'center',
  },
  main_seances: {
    flex: 1,
    //flexDirection: 'row',
    //height: 50,
    //width: 150,
    alignItems: 'center',
},
});
